import React from 'react'
import CheckboxField from '@UI/Form/Fields/Checkbox'
import { getSubDomain } from '@features/Auth'

interface Props {
    i18n: {
        General: {
            Terms_Service_Privacy_Policy: string
        }
    }
}
const TermsCheckbox = ({ i18n }: Props) => {
    const subdomain = getSubDomain()

    return (
        <CheckboxField
            name="terms"
            mustCheck
            label={
                <>
                    {'By continuing, you agree '}
                    {subdomain === 'wic' ? 'to the Terms of Service and Privacy Policy of ' : 'with our '}
                    {subdomain === 'wic' && (
                        <>
                            <a
                                href="https://drive.google.com/file/d/1Av5YAwZ6x8FKR36wNXsADqBXdKDgxFyI/view"
                                target="_blank"
                                rel="noreferrer"
                            >
                                MISA
                            </a>
                            {' and '}
                        </>
                    )}
                    <a href="https://aladdinb2b.com/terms-and-conditions" target="_blank" rel="noreferrer">
                        {subdomain === 'wic'
                            ? 'Aladdin'
                            : i18n?.General?.Terms_Service_Privacy_Policy || 'Terms of Service and Privacy Policy'}
                        .
                    </a>
                </>
            }
        />
    )
}

export default TermsCheckbox
